import { useState } from "react";
import { Icon } from "./icons";

/**
 * "Get this book onto my phone" — a QR straight to this project's player.
 *
 * The phone surface lives outside the app shell, so before this the only way in
 * was to type a URL and then find the right title in a library. Pointing a
 * camera at the screen is one glance, and it lands in THIS book.
 *
 * Collapsed by default: it is a departure action, not something you look at
 * while working, and an always-open QR would push the take list down the page.
 */
export function ListenOnPhone({ projectId }: { projectId: string }) {
  const [open, setOpen] = useState(false);
  const url = `${window.location.origin}/listen/${projectId}`;
  const [copied, setCopied] = useState(false);

  return (
    <section className={`lop${open ? " open" : ""}`}>
      <button className="lop-head" onClick={() => setOpen(!open)} aria-expanded={open}>
        <Icon name="play" size={16} />
        <span className="lop-t">Listen on your phone</span>
        <span className="lop-x">{open ? "Hide" : "Show QR"}</span>
      </button>
      {open && (
        <div className="lop-body">
          <img className="lop-qr" src={`/api/projects/${projectId}/listen-qr.svg`}
            alt={`QR code linking to the phone player for this project`} width={168} height={168} />
          <div className="lop-side">
            <p className="lop-p">
              Point your camera at this to open the book in the phone player. Sign in once,
              then <b>Share → Add to Home Screen</b> and it opens straight to your library
              next time.
            </p>
            <code className="lop-url">{url}</code>
            <button className="lop-copy" onClick={() => {
              navigator.clipboard?.writeText(url).then(() => {
                setCopied(true);
                window.setTimeout(() => setCopied(false), 1600);
              });
            }}>{copied ? "Copied" : "Copy link"}</button>
          </div>
        </div>
      )}
    </section>
  );
}
